import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Descriptions, Table, Card, Divider, Row, Col, Empty } from 'antd';
import { createUseStyles } from 'react-jss'


import dayjs from 'dayjs'
import 'dayjs/locale/ru'
import { Action, GET, POST, QueryDetail, QueryOrder, QueryParam, READWITH, deleteInArray, errorCatch, updateArrayInArray, updateInArray } from 'fennec-ui'
import Rule from '../../../common/Rule'
import { DropdownAction } from 'fennec-ui'

import VPDNovieOtdeleniyaChleniIliIsklyuchenie from '../../forms/VPDNovieOtdeleniyaChleniIliIsklyuchenie'
import VPDZasedaniyaPravleniyaFederatsiiTekst from '../../forms/VPDZasedaniyaPravleniyaFederatsiiTekst'
import OtkritieRegistratsiiNaZasedaniePravleniyaFederatsii from '../../forms/OtkritieRegistratsiiNaZasedaniePravleniyaFederatsii'
import DokumentPrisutstvuyushchieNaZasedaniiPravleniyaFederatsii from '../../forms/DokumentPrisutstvuyushchieNaZasedaniiPravleniyaFederatsii'
import OtkritieZasedaniyaPravleniyaFederatsii from '../../forms/OtkritieZasedaniyaPravleniyaFederatsii'

import REDUX_ZasedaniyaPravleniyaFederatsii from '../../../objects/ZasedaniyaPravleniyaFederatsii/reducer';
import CRUDE_ZasedaniyaPravleniyaFederatsii from '../../../objects/ZasedaniyaPravleniyaFederatsii/crude';

import REDUX_VPDZasedaniyaPravleniyaFederatsii from '../../../objects/VPDZasedaniyaPravleniyaFederatsii/reducer';
import CRUDE_VPDZasedaniyaPravleniyaFederatsii from '../../../objects/VPDZasedaniyaPravleniyaFederatsii/crude';

import REDUX_DokumentPrisutstvuyushchieNaZasedaniiPravleniyaFederatsii from '../../../objects/DokumentPrisutstvuyushchieNaZasedaniiPravleniyaFederatsii/reducer'
import CRUDE_DokumentPrisutstvuyushchieNaZasedaniiPravleniyaFederatsii from '../../../objects/DokumentPrisutstvuyushchieNaZasedaniiPravleniyaFederatsii/crude'
import { If } from 'fennec-ui';
import PageLayout from '../../components/PageLayout';

var utc = require('dayjs/plugin/utc')
var timezone = require('dayjs/plugin/timezone') // dependent on utc plugin
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.locale('ru');

const useStyles = createUseStyles({
    modal: {
        '& .ant-modal-title': {
            marginRight: "25px"
        }
    },
    divider: {
        '&.ant-divider-horizontal.ant-divider-with-text-left': {
            fontFamily: "-apple-system, BlinkMacSystemFont, Roboto, 'Open Sans', 'Helvetica Neue', 'Noto Sans Armenian', 'Noto Sans Bengali', 'Noto Sans Cherokee', 'Noto Sans Devanagari', 'Noto Sans Ethiopic', 'Noto Sans Georgian', 'Noto Sans Hebrew', 'Noto Sans Kannada', 'Noto Sans Khmer', 'Noto Sans Lao', 'Noto Sans Osmanya', 'Noto Sans Tamil', 'Noto Sans Telugu', 'Noto Sans Thai', sans-serif",
            fontSize: "13px",
            fontWeight: "400",
            color: "rgb(0, 0, 0)",
        },
        '&.ant-divider-horizontal.ant-divider-with-text-left .ant-divider-inner-text': {
            padding: "0px",
            marginRight: "10px",
        }
    },
    block: {
        '& .buttons': {
            marginBottom: "10px"
        },
        // '& .buttons .ant-btn': {
        //     border: "none",
        //     '-webkit-box-shadow': "none",
        //     'box-shadow': "none"
        // }
    },
    actionTitle: {
        marginBottom: "5px"
    },

})

function PrisBtn(props) {
    const { auth, prisutstvuyushchie, setPrisutstvuyushchie } = props;
    const dispatch = useDispatch();
    // const prisutstvuyushchie = useSelector(REDUX_DokumentPrisutstvuyushchieNaZasedaniiPravleniyaFederatsii.selector.array);
    const pris_delete = () => {
        GET(auth, `/api/query-delete/DokumentPrisutstvuyushchieNaZasedaniiPravleniyaFederatsii/${props?.object?.ID}`, ({ data }) => {
            setPrisutstvuyushchie(o => deleteInArray(o, props.object))
        }, errorCatch)

        // CRUDE_DokumentPrisutstvuyushchieNaZasedaniiPravleniyaFederatsii.destroy(props.auth, (data) => {
        //     dispatch(REDUX_DokumentPrisutstvuyushchieNaZasedaniiPravleniyaFederatsii.actions.setArray(prisutstvuyushchie.filter(item => item.ID !== props.object.ID).sort((a, b) => {
        //         if (a.ID < b.ID) {
        //             return -1;
        //         }
        //         if (a.ID > b.ID) {
        //             return 1;
        //         }
        //         return 0;
        //     })));
        // }, props.object.ID);
    };
    if (props.object.fixed == true) return <></>;
    return (
        <DropdownAction items={[
            {
                title: "Удалить",
                mode: "MenuItem",
                action: pris_delete
            }
        ]} />
    )
};
function VpdBtn(props) {
    const { auth, voprosi, setVoprosi } = props;
    const dispatch = useDispatch();
    // const voprosi = useSelector(REDUX_VPDZasedaniyaPravleniyaFederatsii.selector.array);
    if (props.object.fixed == true) return <></>;
    const vpd_delete = () => {
        GET(auth, `/api/query-delete/VPDZasedaniyaPravleniyaFederatsii/${props?.object?.ID}`, ({ data }) => {
            setVoprosi(o => deleteInArray(o, props.object))
        }, errorCatch)

        // CRUDE_VPDZasedaniyaPravleniyaFederatsii.destroy(props.auth, (data) => {
        //     dispatch(REDUX_VPDZasedaniyaPravleniyaFederatsii.actions.setArray(voprosi.filter(item => item.ID !== props.object.ID).sort((a, b) => {
        //         if (a.ID < b.ID) {
        //             return -1;
        //         }
        //         if (a.ID > b.ID) {
        //             return 1;
        //         }
        //         return 0;
        //     })));
        // }, props.object.ID);
    };
    const update = (values, unlock, close) => {
        POST(auth, `/api/query-update/VPDZasedaniyaPravleniyaFederatsii`, { ...props.object, ...values }, ({ data }) => {
            if (close) close();
            setVoprosi(o => updateInArray(o, data))
        }, errorCatch)

        CRUDE_VPDZasedaniyaPravleniyaFederatsii.update(props.auth, (data) => {
            if (close) close();
            dispatch(REDUX_VPDZasedaniyaPravleniyaFederatsii.actions.updateArray([data]));
        }, { ...props.object, ...values }, dispatch);
    };
    return (
        <DropdownAction items={[
            If((props.object.chlenFederatsiiID == null && props.object.otdelenieID == null), {
                ...props,
                object: props.object,
                mode: "MenuItem",
                action: update,
                title: "Редактировать",
                form: VPDZasedaniyaPravleniyaFederatsiiTekst,
                document: "vpdzasedaniyapravleniyafederatsiitekst"
            }),
            {
                title: "Удалить",
                mode: "MenuItem",
                action: vpd_delete
            }
        ]} />
    )
};
export default function FederationadministratorFederalgovernmentCurrentmeeting(props) {
    const dispatch = useDispatch();
    const [zasedanie, setZasedanie] = useState();
    const [voprosi, setVoprosi] = useState();
    const [prisutstvuyushchie, setPrisutstvuyushchie] = useState();

    const classes = useStyles();
    const { status } = props;
    const { auth } = props;

    useEffect(() => {
        READWITH(auth, "ZasedaniyaPravleniyaFederatsii", [
            QueryDetail("model"),
            QueryParam("w-in-tekushchiiStatusZasedaniya.ID", "1,2"),
            QueryParam("w-nu-DataOkonchaniyaZasedaniya", "")
        ], ({ data }) => {
            if (data?.length) {
                setZasedanie(data[0]);
            }
        }, errorCatch)
    }, []);
    useEffect(() => {
        if (zasedanie) {
            requestVoprosi(zasedanie);
            requestPrisutstvuyushchie(zasedanie);
        }
    }, [zasedanie]);

    const requestVoprosi = (zasedanie) => {
        if (zasedanie) {
            READWITH(auth, "VPDZasedaniyaPravleniyaFederatsii", [
                QueryDetail("model"),
                QueryParam("w-zasedaniePravleniyaFederatsii.ID", zasedanie?.ID),
            ], ({ data }) => {
                setVoprosi(data);
            }, errorCatch)
        }
    };
    const requestPrisutstvuyushchie = (zasedanie) => {
        if (zasedanie) {
            READWITH(auth, "DokumentPrisutstvuyushchieNaZasedaniiPravleniyaFederatsii", [
                QueryDetail("model"),
                QueryParam("w-zasedaniePravleniyaFederatsii.ID", zasedanie?.ID),
                QueryOrder("chlenFederatsii.user.lastname", "ASC"),
                QueryOrder("chlenFederatsii.user.firstname", "ASC"),
                QueryOrder("chlenFederatsii.user.patronymic", "ASC"),
            ], ({ data }) => {
                setPrisutstvuyushchie(data);
            }, errorCatch)
        }
    };

    const Current = (props) => {
        const dispatch = useDispatch();
        const { object, zasedanie } = props;

        if (!zasedanie || !zasedanie.mestoProvedeniyaZasedaniya) return (
            <Empty description={"Нет текущего заседания"} style={{ paddingBottom: "40px" }} />
        );
        // const p = [...prisutstvuyushchie].sort((a, b) => {
        //     var ai = a.chlenFederatsii.user.lastname + " " + a.chlenFederatsii.user.firstname + " " + a.chlenFederatsii.user.patronymic;
        //     var bi = b.chlenFederatsii.user.lastname + " " + b.chlenFederatsii.user.firstname + " " + b.chlenFederatsii.user.patronymic;
        //     if (ai < bi) {
        //         return -1;
        //     }
        //     if (ai > bi) {
        //         return 1;
        //     }
        //     // a должно быть равным b
        //     return 0;
        // }).map(item => (
        //     <div key={item.ID}>
        //         {item.chlenFederatsii.user.lastname + " " + item.chlenFederatsii.user.firstname + " " + item.chlenFederatsii.user.patronymic}
        //     </div>
        // ));
        return (
            <Descriptions bordered column={{ xs: 1, sm: 1, md: 1 }} size={"small"} >
                <Descriptions.Item label="Номер протокола заседания">{zasedanie?.nomerProtokolaZasedaniya}</Descriptions.Item>
                <Descriptions.Item label="Дата заседания">{dayjs(zasedanie?.dataZasedaniya).tz("Europe/Moscow").format('DD.MM.YYYY HH:mm')}</Descriptions.Item>
                <Descriptions.Item label="Место проведения заседания">{zasedanie?.mestoProvedeniyaZasedaniya.name}</Descriptions.Item>
                <Descriptions.Item label="Необходимый кворум">{zasedanie?.neobkhodimiiKvorum}%</Descriptions.Item>
                <Descriptions.Item label="Количество вопросов повестки дня">{voprosi?.length}</Descriptions.Item>
            </Descriptions>
        );
    };
    const openCallback = (res) => {

        setZasedanie(res.data.zasedaniePravleniyaFederatsii);
        // dispatch(REDUX_ZasedaniyaPravleniyaFederatsii.actions.setObject(res.data.zasedaniePravleniyaFederatsii));
        requestPrisutstvuyushchie(zasedanie);

    };
    const registerCallback = (res) => {

        setZasedanie(res.data.zasedaniePravleniyaFederatsii);
        // dispatch(REDUX_ZasedaniyaPravleniyaFederatsii.actions.setObject(res.data.zasedaniePravleniyaFederatsii));
        requestVoprosi(zasedanie);
        requestPrisutstvuyushchie(zasedanie);
    };
    const voprosiCallback = (res) => {
        if (res.data.length <= 0) return;
        setZasedanie(res.data[0].zasedaniePravleniyaFederatsii);
        // dispatch(REDUX_ZasedaniyaPravleniyaFederatsii.actions.setObject(res.data[0].zasedaniePravleniyaFederatsii));
        setVoprosi(o => updateArrayInArray(o, res.data))
        // dispatch(REDUX_VPDZasedaniyaPravleniyaFederatsii.actions.updateArray(res.data.sort((a, b) => {
        //     if (a.ID < b.ID) {
        //         return -1;
        //     }
        //     if (a.ID > b.ID) {
        //         return 1;
        //     }
        //     return 0;
        // })));
    };
    const prisutstvuyushchieCallback = (res) => {
        if (res.data.length <= 0) return;
        setZasedanie(res.data[0].zasedaniePravleniyaFederatsii);
        // dispatch(REDUX_ZasedaniyaPravleniyaFederatsii.actions.setObject(res.data[0].zasedaniePravleniyaFederatsii));
        // dispatch(REDUX_DokumentPrisutstvuyushchieNaZasedaniiPravleniyaFederatsii.actions.updateArray(res.data));
        setPrisutstvuyushchie([...prisutstvuyushchie, ...res.data]);
    };
    const prisColumns = [
        {
            render: (text, record, index) => {
                return (record.chlenFederatsii.user.lastname + " " + record.chlenFederatsii.user.firstname + " " + record.chlenFederatsii.user.patronymic);
            }
        },
        {
            render: (text, record, index) => {
                if (record.prezidentFederatsiiID) return ("Президент федерации");
                if (record.revizorFederatsiiID) return ("Ревизор федерации");
                if (record.chlenPravleniyaFederatsiiID) return ("Член правления федерации");
            }
        },
        {
            title: '',
            dataIndex: '',
            key: 'x',
            fixed: 'right',
            width: 45,
            render: (text, record, index) => (<PrisBtn auth={auth} index={index + 1} prisutstvuyushchie={prisutstvuyushchie} setPrisutstvuyushchie={setPrisutstvuyushchie} object={record} callback={(res) => {
                requestPrisutstvuyushchie(zasedanie);
            }} />),
        },
    ];
    const vpdColumns = [
        {
            title: '№',
            render: (text, record, index) => {
                return (index + 1);
            }
        },
        {
            title: 'Вопрос',
            render: (text, record, index) => {
                return (record.voprosPovestkiDnya);
            }
        },
        {
            title: '',
            dataIndex: '',
            key: 'x',
            fixed: 'right',
            width: 45,
            render: (text, record, index) => (<VpdBtn auth={auth} index={index + 1} voprosi={voprosi} setVoprosi={setVoprosi} object={record} callback={(res) => {
                requestVoprosi(zasedanie);
            }} />),
        },
    ];
    return (
        <PageLayout>
            <div style={{ backgroundColor: "white", borderRadius: "4px" }}>
                <div style={{ padding: "10px" }}>
                    <div>
                        <Divider className={classes.divider} type="horizontal" orientation="left">
                            Текущее заседание правления федерации
                        </Divider>

                        <Current zasedanie={zasedanie} />

                        <Divider className={classes.divider} type="horizontal" orientation="left">
                            Вопросы повестки дня
                        </Divider>
                        <Table columns={vpdColumns} dataSource={voprosi} pagination={false} showHeader={false} style={{ paddingBottom: "15px" }} locale={{ emptyText: <Empty description={"Нет вопросов повестки дня"}></Empty> }} size="small" rowKey={(r) => r.ID} />

                        <Divider className={classes.divider} type="horizontal" orientation="left">
                            Присутствующие на заседании
                        </Divider>
                        <Table columns={prisColumns} dataSource={prisutstvuyushchie} pagination={false} showHeader={false} style={{ paddingBottom: "15px" }} locale={{ emptyText: <Empty description={"Нет присутствующих на заседании"}></Empty> }} size="small" rowKey={(r) => r.ID} />

                        <Rule type={"vpdnovieotdeleniyachleniiliisklyuchenie"} object={zasedanie}>
                            <Action
                                auth={auth}
                                //  callback={voprosiCallback}
                                title={"ВПД Новые Отделения Члены или Исключение"}
                                form={VPDNovieOtdeleniyaChleniIliIsklyuchenie}
                                zasedanie={zasedanie}
                                //  document={"vpdnovieotdeleniyachleniiliisklyuchenie"}
                                action={(values, unlock, close) => {
                                    POST(auth, `/api/vpdnovieotdeleniyachleniiliisklyuchenie`, values,
                                        (res) => {
                                            voprosiCallback(res)
                                            close()
                                        }, (err) => errorCatch(err, unlock)
                                    )
                                }}
                            />
                        </Rule>

                        <Rule type={"vpdzasedaniyapravleniyafederatsiitekst"} object={zasedanie}>
                            <Action
                                auth={auth}
                                //  callback={voprosiCallback}
                                title={"ВПД Заседания Правления Федерации Текст"}
                                form={VPDZasedaniyaPravleniyaFederatsiiTekst}
                                zasedanie={zasedanie}
                                //  document={"vpdzasedaniyapravleniyafederatsiitekst"}
                                action={(values, unlock, close) => {
                                    POST(auth, `/api/vpdzasedaniyapravleniyafederatsiitekst`, {...values, zasedaniePravleniyaFederatsiiID: zasedanie?.ID},
                                        (res) => {
                                            voprosiCallback(res)
                                            close()
                                        }, (err) => errorCatch(err, unlock)
                                    )
                                }}
                            />
                        </Rule>

                        <Rule type={"otkritieregistratsiinazasedaniepravleniyafederatsii"} object={zasedanie}>
                            <Action
                                auth={auth}
                                //  callback={registerCallback}
                                title={"Открытие Регистрации На Заседание Правления Федерации"}
                                form={OtkritieRegistratsiiNaZasedaniePravleniyaFederatsii}
                                zasedanie={zasedanie}
                                //  document={"otkritieregistratsiinazasedaniepravleniyafederatsii"}
                                action={(values, unlock, close) => {
                                    POST(auth, `/api/otkritieregistratsiinazasedaniepravleniyafederatsii`, values,
                                        (res) => {
                                            registerCallback(res)
                                            close()
                                        }, (err) => errorCatch(err, unlock)
                                    )
                                }}
                            />
                        </Rule>

                        <Rule type={"dokumentprisutstvuyushchienazasedaniipravleniyafederatsii"} object={zasedanie}>
                            <Action
                                auth={auth}
                                //  callback={prisutstvuyushchieCallback}
                                title={"Присутствующие На Заседании Правления Федерации"}
                                form={DokumentPrisutstvuyushchieNaZasedaniiPravleniyaFederatsii}
                                zasedanie={zasedanie}
                                //  document={"dokumentprisutstvuyushchienazasedaniipravleniyafederatsii"}
                                action={(values, unlock, close) => {
                                    POST(auth, `/api/dokumentprisutstvuyushchienazasedaniipravleniyafederatsii`, values,
                                        (res) => {
                                            prisutstvuyushchieCallback(res)
                                            close()
                                        }, (err) => errorCatch(err, unlock)
                                    )
                                }}
                            />
                        </Rule>

                        <Rule type={"otkritiezasedaniyapravleniyafederatsii"} object={zasedanie}>
                            <Action
                                auth={auth}
                                //  callback={openCallback}
                                title={"Открытие Заседания Правления Федерации"}
                                form={OtkritieZasedaniyaPravleniyaFederatsii}
                                zasedanie={zasedanie}
                                prisutstvuyushchie={prisutstvuyushchie}
                                //  document={"otkritiezasedaniyapravleniyafederatsii"}
                                action={(values, unlock, close) => {
                                    POST(auth, `/api/otkritiezasedaniyapravleniyafederatsii`, values,
                                        (res) => {
                                            openCallback(res)
                                            close()
                                        }, (err) => errorCatch(err, unlock)
                                    )
                                }}
                            />
                        </Rule>

                    </div>
                </div>
            </div>
        </PageLayout>
    );
}
